import PropTypes from "prop-types";
import { IconButton, Tooltip } from "@mui/material";
import { Trash2 } from "lucide-react";

import { ConfirmModal } from "../../../components/ConfirmModal";

/** Trash icon for the side panel header. */
export const DeleteIconButton = ({ label, onClick, disabled }) => (
  <Tooltip title={label}>
    <IconButton aria-label={label} onClick={onClick} disabled={disabled} sx={{ color: "error.main" }}>
      <Trash2 size={18} />
    </IconButton>
  </Tooltip>
);

DeleteIconButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

/** "¿Estás seguro…?" confirmation before deleting a record in Clientify. */
export const ClientifyDeleteModal = ({ open, noun, name, detail, deleting, onCancel, onConfirm }) => (
  <ConfirmModal
    open={open}
    onClose={onCancel}
    onConfirm={onConfirm}
    title={`Eliminar ${noun}`}
    question={`¿Estás seguro de que quieres eliminar ${noun === "oportunidad" ? "esta" : "este"} ${noun}?`}
    description={
      <>
        Se eliminará de Clientify <strong>{name}</strong>
        {detail ? ` ${detail}` : ""}. Esta acción no se puede deshacer.
      </>
    }
    confirmLabel={`Eliminar ${noun}`}
    loadingLabel="Eliminando..."
    loading={deleting}
    tone="danger"
  />
);

ClientifyDeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  noun: PropTypes.string.isRequired,
  name: PropTypes.string,
  detail: PropTypes.string,
  deleting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
